import { Button, Navbar } from '@codeparva/ui-components-library';
import { Link } from '@reach/router';
import { weakKey } from '../../../../../utilities/weakKey';
import { TenantAvatar } from './TenantAvatar';
import React, { useEffect, useState } from 'react';
import { NavBarTypes } from '../navBarTypes';
import { getCookies } from '../../../../rentalPage/components/dynamicForm/helper/cookiesHelper';
import { useVariant } from '../hooks/NavBarContext';
import { getCurrentLocation } from './SignInAvatarHelpers';

export const SignInAvatarComponent = ({
  buttonsConfig,
  globalContext,
  handleNavBarFunctions,
  logOutHandler,
}: NavBarTypes.TSignInAvatarComponentTypes) => {
  const {
    locationDetails: [{ location_state = '', location_city = '' } = {}] = [],
    locationDetails: locations,
  } = useVariant();
  const loginUrl =
    location_state && location_city
      ? `/${location_state}/${location_city}/account/login`
      : '/account/login';
  const accountSelectionUrl = loginUrl
    ? loginUrl.replace('login', 'account-selection')
    : '';
  const tokenFromCookies = getCookies('cToken') || '';
  const [isTenantSignedIn, setIsTenantSignedIn] = useState(false);
  const { tenantName = {} } = globalContext || {};

  useEffect(() => {
    if (tokenFromCookies != '' && Object.values(tenantName).length > 0) {
      setIsTenantSignedIn(true);
    } else {
      setIsTenantSignedIn(false);
    }
  }, [tokenFromCookies, tenantName]);

  const handleSigninOnclick = (e: any) => {
    handleNavBarFunctions.handleNavBarStateButton(e);
  };

  const RenderSignInOrAvatar = () => {
    if (isTenantSignedIn) {
      const currentLocation = getCurrentLocation(
        locations,
        globalContext?.loggedInSmsFacilityId
      );
      return (
        <TenantAvatar
          globalContext={globalContext}
          logOutHandler={logOutHandler}
          accountSelectionUrl={accountSelectionUrl}
          currentLocation={currentLocation}
          siteType={locations?.length > 1 ? 'multi' : 'single'}
        />
      );
    } else {
      return (
        <Button rounded className="signInButton">
          <Link
            to={loginUrl}
            onClick={e => handleSigninOnclick(e)}
            key={weakKey(buttonsConfig)}
            state={{
              from: buttonsConfig?.[0]?.label.toLowerCase().replace(/\s/g, ''),
              dataFrom: 'ctaButton',
            }}
            className="subtitle1"
          >
            Sign In
          </Link>
        </Button>
      );
    }
  };

  return (
    <Navbar.Item
      href="#"
      renderAs="div"
      className="navBarButtons"
      style={{ width: 'auto', cursor: 'pointer', border: 'none' }}
    >
      <RenderSignInOrAvatar />
    </Navbar.Item>
  );
};
